import { ref } from "vue";
import { getStatuses, pickArray } from "@/entities/workflow/api";

const DEFAULT_COLOR = "#6B7280";

const statusMap = ref(new Map());
const loading = ref(false);
let loadPromise = null;

export function ensureStatusDictionary() {
  if (statusMap.value.size > 0) return Promise.resolve(statusMap.value);
  if (loadPromise) return loadPromise;
  loading.value = true;
  loadPromise = getStatuses()
    .then((res) => {
      if (res?.success) {
        const items = pickArray(res.payload);
        const map = new Map();
        for (const s of items) {
          if (s?.code) map.set(s.code, s);
        }
        statusMap.value = map;
      }
      return statusMap.value;
    })
    .finally(() => {
      loading.value = false;
      loadPromise = null;
    });
  return loadPromise;
}

export function getStatusLabel(code) {
  if (!code) return "";
  return statusMap.value.get(code)?.label || code;
}

export function getStatusColor(code) {
  if (!code) return DEFAULT_COLOR;
  return statusMap.value.get(code)?.color || DEFAULT_COLOR;
}

export function getStatusDictionary() {
  return statusMap;
}

export function isStatusDictionaryLoading() {
  return loading;
}

// Источник правды по статусам — GET /template-action-rules/statuses.
//
// StatusCode — это Proxy над словарём статусов:
//  - StatusCode.X → строка "X" для семантических проверок
//    (например: form.status === StatusCode.COMPLETED)
//  - Object.keys(StatusCode) / for..in / "X" in StatusCode — отдают
//    реальный список кодов, подтянутый из бекенда. Первое обращение к
//    перечислению/`has` лениво триггерит загрузку словаря.
export const StatusCode = new Proxy(
  {},
  {
    get(_, prop) {
      return typeof prop === "string" ? prop : undefined;
    },
    has(_, prop) {
      if (typeof prop !== "string") return false;
      ensureStatusDictionary();
      return statusMap.value.has(prop);
    },
    ownKeys() {
      ensureStatusDictionary();
      return Array.from(statusMap.value.keys());
    },
    getOwnPropertyDescriptor(_, prop) {
      if (typeof prop !== "string") return undefined;
      if (!statusMap.value.has(prop)) return undefined;
      return {
        enumerable: true,
        configurable: true,
        writable: false,
        value: prop,
      };
    },
  }
);
